import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import Pagination from "react-js-pagination";
import "../../../components/Style/Table.css"
import SharePopUp from "./SharePopUp";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter
} from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import PeopleIcon from "@material-ui/icons/People";

export default function ProjectTable(props){
  const filterKeyword = props.filterKeyword || '';
  const row = props.row;
  const searchTargets = props.searchTargets;
  const totalData = props.totalData;
  const [dataCnt, setDataCnt] = useState(0);

  // pagination
  const [page, setPage] = useState(1);
  const [currentPost, setCurrentPost] = useState([]);
  const postPerPage = 10;
  const handlePageChange = (page) => {
    setPage(page);
  };

  const [open, setOpen] = useState(false);
  const [selectedProjectID, setSelectedProjectID] = useState();
  const [selectedOwnerName, setSelectedOwnerName] = useState("");
  const shareClickOpen = (item) => {
    setOpen(true);
    setSelectedProjectID(item.project_id);
    setSelectedOwnerName(item.name || "");
  };

  const shareClose = () => {
    setOpen(false);
    setSelectedProjectID(null);
    setSelectedOwnerName("");
  };

  const searchItem = (filterKeyword) => {
    if (filterKeyword !== ''){
      const filteredData = totalData.filter((item) => {
        return searchTargets.some((target) => {
          if (item[target] == null) return false;
          return String(item[target]).toLowerCase().includes(filterKeyword.toLowerCase());
        });
      });
      // pagination filter data slice
      setCurrentPost(filteredData.slice(page*postPerPage-postPerPage, page*postPerPage));
      setDataCnt(filteredData.length);
    } else {
      // pagination total data slice
      setCurrentPost(totalData.slice(page*postPerPage-postPerPage, page*postPerPage));
      setDataCnt(totalData.length);
    }
  }

  useEffect(() => {
    searchItem(filterKeyword)
  }, [totalData, page, filterKeyword])

  return(
    <div>
      <TableContainer>
        <Table className="mb-0">
          <TableHead>
            <TableRow>
              {row && row.map(headerItem => (
                <TableCell style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '15px'}}>{headerItem}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {currentPost && currentPost.map(item => (
              <TableRow key={item.num}>
                <TableCell style={{ textAlign: 'center'}}>{item.project_id}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>
                  <TitleWrap>
                    <span>{item.project_name}</span>
                    {item.project_id ? (
                      <GoLink
                        href={`https://researchall.net/project/${item.project_id}/analysis/board`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="리서치올에서 보기"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <OpenInNewIcon fontSize="small" />
                      </GoLink>
                    ) : null}
                  </TitleWrap>
                </TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.name}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.created_at}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.data_process_status}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.patent_cnt}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>
                  <ShareBtn type="button" onClick={() => shareClickOpen(item)} $empty={!Number(item.shared_member_ids)}>
                    <PeopleIcon fontSize="small" />
                    {Number(item.shared_member_ids) > 0
                      ? `${Number(item.shared_member_ids)}명`
                      : "공유하기"}
                  </ShareBtn>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <RealTableFooter>
          <Pagination
            activePage={page}
            itemsCountPerPage={postPerPage}
            totalItemsCount={dataCnt}
            pageRangeDisplayed={5}
            prevPageText={"<"}
            nextPageText={">"}
            onChange={handlePageChange}
          />
        </RealTableFooter>
      </TableContainer>
      <SharePopUp open={open} close={shareClose} project_id={selectedProjectID} ownerName={selectedOwnerName}/>
    </div>
  )
}

const RealTableFooter = styled (TableFooter)`
    display: flex;
    justify-content: center;
    text-align: center;
`

const TitleWrap = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    max-width: 100%;
`

const GoLink = styled.a`
    display: inline-flex;
    align-items: center;
    color: #94a3b8;
    flex-shrink: 0;
    line-height: 0;
    transition: color 0.15s ease, transform 0.15s ease;

    &:hover {
        color: #536dfe;
        transform: translateY(-1px);
    }

    svg {
        font-size: 16px;
    }
`

const ShareBtn = styled.button`
    appearance: none;
    font: inherit;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-width: 92px;
    height: 34px;
    padding: 0 12px;
    border-radius: 999px;
    border: 1px solid ${({ $empty }) => ($empty ? "#dbe3ee" : "transparent")};
    background: ${({ $empty }) => ($empty ? "#ffffff" : "#536dfe")};
    color: ${({ $empty }) => ($empty ? "#475569" : "#ffffff")};
    font-size: 13px;
    font-weight: 700;
    letter-spacing: -0.2px;
    cursor: pointer;
    box-shadow: ${({ $empty }) =>
      $empty ? "none" : "0 6px 14px rgba(83, 109, 254, 0.28)"};
    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, border-color 0.15s ease;

    svg {
        font-size: 16px;
    }

    &:hover {
        transform: translateY(-1px);
        background: ${({ $empty }) => ($empty ? "#f8fafc" : "#3d5afe")};
        border-color: ${({ $empty }) => ($empty ? "#536dfe" : "transparent")};
        color: ${({ $empty }) => ($empty ? "#536dfe" : "#ffffff")};
        box-shadow: 0 8px 16px rgba(83, 109, 254, 0.22);
    }
`